import { render, staticRenderFns } from "./uav.vue?vue&type=template&id=14b6eb76&scoped=true&"
import script from "./uav.vue?vue&type=script&lang=js&"
export * from "./uav.vue?vue&type=script&lang=js&"
import style0 from "./uav.vue?vue&type=style&index=0&id=14b6eb76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b6eb76",
  null
  
)

export default component.exports